import Vue from 'vue'
import store from '@/store/'
import {
  DEFAULT_COLOR,
  DEFAULT_THEME,
  DEFAULT_LAYOUT_MODE,
  DEFAULT_COLOR_WEAK,
  SIDEBAR_TYPE,
  DEFAULT_FIXED_HEADER,
  DEFAULT_FIXED_HEADER_HIDDEN,
  DEFAULT_FIXED_SIDEMENU,
  DEFAULT_CONTENT_WIDTH_TYPE,
  DEFAULT_MULTI_TAB
} from '@/store/mutation-types'
import config from '@/config/defaultSettings'

export default function Initializer () {
  store.commit('SET_SIDEBAR_TYPE', (process.env.NODE_ENV === 'production' ? true : Vue.ls.get(SIDEBAR_TYPE, true)))
  store.commit('TOGGLE_THEME', (process.env.NODE_ENV === 'production' ? config.navTheme : Vue.ls.get(DEFAULT_THEME, config.navTheme)))
  store.commit('TOGGLE_LAYOUT_MODE', (process.env.NODE_ENV === 'production' ? config.layout : Vue.ls.get(DEFAULT_LAYOUT_MODE, config.layout)))
  store.commit('TOGGLE_FIXED_HEADER', (process.env.NODE_ENV === 'production' ? config.fixedHeader : Vue.ls.get(DEFAULT_FIXED_HEADER, config.fixedHeader)))
  store.commit('TOGGLE_FIXED_SIDERBAR', (process.env.NODE_ENV === 'production' ? config.fixSiderbar : Vue.ls.get(DEFAULT_FIXED_SIDEMENU, config.fixSiderbar)))
  store.commit('TOGGLE_CONTENT_WIDTH', (process.env.NODE_ENV === 'production' ? config.contentWidth : Vue.ls.get(DEFAULT_CONTENT_WIDTH_TYPE, config.contentWidth)))
  store.commit('TOGGLE_FIXED_HEADER_HIDDEN', (process.env.NODE_ENV === 'production' ? config.autoHideHeader : Vue.ls.get(DEFAULT_FIXED_HEADER_HIDDEN, config.autoHideHeader)))
  store.commit('TOGGLE_WEAK', (process.env.NODE_ENV === 'production' ? config.colorWeak : Vue.ls.get(DEFAULT_COLOR_WEAK, config.colorWeak)))
  store.commit('TOGGLE_COLOR', (process.env.NODE_ENV === 'production' ? config.primaryColor : Vue.ls.get(DEFAULT_COLOR, config.primaryColor)))
  store.commit('TOGGLE_MULTI_TAB', (process.env.NODE_ENV === 'production' ? config.multiTab : Vue.ls.get(DEFAULT_MULTI_TAB, config.multiTab)))
  // last step
}
